<template>
  <b-modal
    v-model="visible"
    title="ประวัติการทบทวนสุขภาพ"
    size="lg"
    hide-footer
    @shown="load"
  >
    <p
      v-if="updatedText"
      class="text-muted small-text mb-2"
    >
      ข้อมูลสุขภาพอัปเดตล่าสุด {{ updatedText }}
    </p>
    <div
      v-if="isLoading"
      class="text-muted"
    >
      กำลังโหลด...
    </div>
    <div
      v-else-if="!rows.length"
      class="text-muted"
    >
      ยังไม่มีประวัติการทบทวน
    </div>
    <div
      v-for="r in rows"
      :key="r.appointmentId"
      class="border-bottom py-2"
    >
      <div>
        <b>{{ fmt(r.healthReviewDt || r.startDt) }}</b>
      </div>
      <div v-if="lines(r).length">
        <div
          v-for="(l, i) in lines(r)"
          :key="i"
        >
          {{ l }}
        </div>
      </div>
      <div
        v-else
        class="text-muted"
      >
        ไม่มีเปลี่ยนแปลง
      </div>
      <div class="small-text text-muted">
        {{ reviewerName(r) }} ({{ source(r) }})
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
import { eventBus } from "@/main";
import {
  describeHealthChanges,
  SOURCE_LABELS,
  stampText,
} from "@/utils/healthReview";

export default {
  name: "HealthHistoryModal",
  props: {
    patientId: { type: [Number, String], default: null },
    // optional: the patient object, for the "อัปเดตล่าสุด" line
    patient: { type: Object, default: null },
  },
  data() {
    return { visible: false, isLoading: false, rows: [] };
  },
  computed: {
    updatedText() {
      return stampText(this.patient?.healthUpdatedDt, this.patient?.healthUpdatedU);
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    async load() {
      this.isLoading = true;
      try {
        const res = await this.$store.dispatch(
          "moduleAppointment/fetchHealthHistory",
          {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            patientId: this.patientId,
          }
        );
        this.rows = res.data || [];
      } catch (e) {
        this.rows = [];
        eventBus.$emit("alertToast", {
          message: "โหลดประวัติการทบทวนไม่สำเร็จ",
          variant: "danger",
        });
      } finally {
        this.isLoading = false;
      }
    },
    fmt(dt) {
      return dt ? moment(dt).format("D MMM YY HH:mm") : "-";
    },
    lines(r) {
      return describeHealthChanges(r.healthReviewChanges);
    },
    source(r) {
      return SOURCE_LABELS[r.healthReviewSource] || "-";
    },
    reviewerName(r) {
      const v = r.reviewer;
      if (!v) return "-";
      if (typeof v === "string") return v;
      return (
        v.name || [v.firstNameTh, v.lastNameTh].filter(Boolean).join(" ") || "-"
      );
    },
  },
};
</script>
